export default "__VITE_ASSET__C8ndmZ5Q__"